import type { CampaignTemplate } from '@/data'
import api from '../..'

export interface TemplatePayload {
  name: string
  text: string
  ordinal?: number
}

export async function createTemplate(
  campaignId: string,
  payload: TemplatePayload,
): Promise<CampaignTemplate> {
  const res = await api.post(`/campaigns/${campaignId}/templates`, payload)
  return res.data.data
}
